import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; // <- import
import "./PaymentPicker.css";
import theme from "../../styles/theme.json";

const PaymentPicker = ({ cartoes, agendamento, setAgendamento }) => {
  const navigate = useNavigate(); // <- hook para navegação

  const [formData, setFormData] = useState({
    nomeTitular: "",
    dataExpiracao: "",
    cvv: "",
    numeroCartao: "",
  });

  const handleCartaoSelect = (cartao) => {
    setAgendamento({
      ...agendamento,
      cartaoId: cartao._id,
      cartaoUltimosDigitos: cartao.numeroFinal,
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCVVChange = (cvv) => {
    setAgendamento({ ...agendamento, cartaoCVV: cvv });
  };

  const handleExpiracaoChange = (e) => {
    let value = e.target.value.replace(/[^0-9]/g, "");
    if (value.length > 2) {
      value = value.slice(0, 2) + "/" + value.slice(2, 4);
    }
    setFormData({ ...formData, dataExpiracao: value });
  };

  const handleNumeroCartaoChange = (e) => {
    let value = e.target.value.replace(/\D/g, "");
    if (value.length > 4) {
      value = value.replace(/(\d{4})(\d{1,4})$/, "$1 $2");
    }
    setFormData({ ...formData, numeroCartao: value });
  };

  return (
    <div className="payment-picker">
      {cartoes && cartoes.length > 0 ? (
        <>
          <div className="card-selector">
            {cartoes.map((cartao) => (
              <div
                key={cartao._id}
                className={`card-option ${
                  agendamento.cartaoId === cartao._id ? "selected" : ""
                }`}
                onClick={() => handleCartaoSelect(cartao)}
              >
                <span>**** **** **** {cartao.numeroFinal}</span>
              </div>
            ))}
          </div>
          <div className="cvv-input">
            <label>CVV:</label>
            <input
              type="numeric"
              maxLength="3"
              value={agendamento.cartaoCVV}
              onChange={(e) => handleCVVChange(e.target.value)}
            />
          </div>
        </>
      ) : (
        <div className="no-cards">
          <p>Você ainda não tem nenhum cartão cadastrado.</p>
          <button
            className="add-card-button"
            onClick={() => navigate("/area-restrita/minha-conta/metodos-pagamento/add")}
          >
            Cadastrar cartão
          </button>
        </div>
      )}
    </div>
  );
};

export default PaymentPicker;
